import Lilly from "../../assets/logo/logo.svg";

const Maintenance = () => {
  return (
    <div className="bg-white h-[95vh] w-full flex flex-col items-center justify-center">
      <div>
        <img src={Lilly} />
      </div>
      <div className="text-center">
        <div className="text-lg font-medium">Site is under maintenance!</div>
        <div>We will be back shortly.</div>
      </div>
    </div>
  );
};

export default Maintenance;
